<div class="grid place-content-center">
    <app-icon (click)="onUserSwitchClick()" class="icon-black hover:cursor-pointer icon-3.5" [name]="'mdi:account-switch'" />
</div>
